import {Injectable} from "@angular/core";
import {
    ChartData,
    DatasetTypes,
    DeviceStateData,
    DiagramData,
    ElementTypes,
    GaugeData,
    SingleValueData,
    WidgetElement,
    WidgetElementData
} from "@entities/widget-element";

@Injectable({providedIn: "root"})
export class CreateElementService {
    createNewElement(id: number, type: ElementTypes, x: number, y: number): WidgetElement {
        return {
            id: String(id),
            x: x,
            y: y,
            w: 1,
            h: 1,
            data: this.createElementData(type)
        };
    }

    private createElementData(type: ElementTypes): WidgetElementData {
        switch (type) {
            case ElementTypes.CHART:
                return this.createChartData();
            case ElementTypes.DIAGRAM:
                return this.createDiagramData();
            case ElementTypes.GAUGE:
                return this.createGaugeData();
            case ElementTypes.SINGLE_VALUE:
                return this.createSingleValueData();
            case ElementTypes.DEVICE_STATE:
                return this.createDeviceStateData();
        }
    }

    private createChartData(): ChartData {
        return {
            content: {
                name: "Новый график",
                elementType: ElementTypes.CHART,
                datasets: []
            },
            metadata: {
                temporalCount: 0,
                precision: 100,
            }
        };
    }

    private createDiagramData(): DiagramData {
        return {
            content: {
                name: "Новая диаграмма",
                elementType: ElementTypes.DIAGRAM,
                datasets: []
            },
            metadata: {
                datasetType: DatasetTypes.CURRENT_VALUE,
                temporalCount: 0,
            }
        };
    }

    private createGaugeData(): GaugeData {
        return {
            content: {
                name: "Новая шкала",
                elementType: ElementTypes.GAUGE,
                datasets: []
            },
            metadata: {
                threshold: {
                    min: 0,
                    max: 0,
                },
                settings: {}
            }
        };
    }

    private createSingleValueData(): SingleValueData {
        return {
            content: {
                name: "Новое текущее значение",
                elementType: ElementTypes.SINGLE_VALUE,
                datasets: []
            },
            metadata: {}
        };
    }

    private createDeviceStateData(): DeviceStateData {
        return {
            content: {
                name: "Новое состояние оборудования",
                elementType: ElementTypes.DEVICE_STATE,
                datasets: []
            },
            metadata: {}
        };
    }
}
